<template>
	<div>
		<div>
			<div class=" text-left" style="margin-bottom: 20px;">
				<el-carousel>
					<el-carousel-item v-for="(item, index) in list_a" :key="index">
						<h3 class="small">
							<img style="width: 100%; height: 100%;" src="https://img.hsnms.com/20220425/1650824285.jpg" alt />
						</h3>
					</el-carousel-item>
				</el-carousel>
			</div>


			<el-row>
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<div class="row" style="padding-top: 20px; padding-bottom: 20px;">
							<div class="col-1"></div>
							<div class="col-11">
								<h4>绿地·德加公馆</h4>
								<h5 style="color: #c5114f; margin-top: 20px;">首付32万起</h5>
								<h5 style="margin-top: 20px;">
									<el-tag type="info">标签三</el-tag>
									<el-tag type="info">标签三</el-tag>
									<el-tag type="info">标签三</el-tag>
									<el-tag type="info">标签三</el-tag>
								</h5>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
			
			
			<el-row>
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<h4 class="h_hei" style="padding-top: 10px;">特惠专区</h4>
						<div class="row" style="padding:10px;">
							<div class="col-12">
								<img style="width: 100%;" src="https://img.hsnms.com/20220425/1650824113.png"/>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
			
			<el-row>
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<h4 class="h_hei" style="padding-top: 10px;">户型图</h4>
						<div class="row"  style="height: 400px;">
							<div class="col-12">
								<el-carousel style="height: 400px;">
									<el-carousel-item v-for="(item, index) in list_a" :key="index" style="height: 400px;">
										<h3 class="small">
											<img style="width: 100%; height: 100%;" src="http://wx.tzcs0576.com/Uploads/img/2020-04/1586955551img1.jpg" alt />
										</h3>
									</el-carousel-item>
								</el-carousel>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
			
			<el-row>
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<h4 class="h_hei" style="padding-top: 10px;">项目信息</h4>
						<div class="row" >
							<div class="col-12" style="margin: 10px; line-height: 25px;">
								<div>销售价格：17000元/m²</div>
								<div>开盘时间：2019年5月29日</div>
								<div>入住时间：暂无</div>
								<div>销售许可：椒售许字（2020）第00038号</div>
								<div>售楼地址：椒江区工人西路与富强路交叉口</div>
								<div>物业类型：高层、洋房</div>
								<div>装修情况：精装</div>
								<div>产权年限：住宅70年</div>
								<div>占地面积：112112㎡</div>
								<div>建筑面积：约35万㎡</div>
								<div>容积率：2.3</div>
								<div>绿化率：30%</div>
								<div>开发商：台州绿地山海房地产开发有限公司</div>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
			
			
			<el-row>
				<el-col :span="24">
					<div class="grid-content bg-purple-dark">
						<h4 class="h_hei" style="padding-top: 10px;">位置及周边</h4>
						<div class="row"  style="width: 100%;">
							<div class="col-12" style="margin: 10px; line-height: 25px;">
								<img style="width: 100%;" src="https://img.hsnms.com/20220425/1650824568.webp"/>
								<div style="margin-top: 20px;">交通：137路</div>
								<div>教育：华东师范大学附属台州学校、校</div>
								<div>周边：青悦城、东商务区（意得百货）</div>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
			
			
			
			
		
				<h4 class="h_hei">参展楼盘</h4>
				<div class="row t_b" style="text-align: center;">
					<div class="col-xs-12" style="margin-bottom: 20px; margin-top: -10px;">
						<el-carousel>
							<el-carousel-item v-for="(item, index) in list_b" :key="index">
								<h3 class="small">
									<img style="width: 100%; height: 100%; border-radius:5px;" :src="item.value_a"
										alt />
								</h3>
							</el-carousel-item>
						</el-carousel>

					</div>
					<div style="margin-bottom: 20px;" class="col-xs-6"
						v-for="(item, index) in [2,3,3,2,4,5,2,3,3,2,4,5,5,2,4,5,2,4,5,4]">

						<div style="position:relative;width:100%;">
							<img style="width: 100%; border-radius:3%;"
								src="http://www.baiduhrb.com/fjhht/upload/Project/202003/3542323865e5fcc08644c3_400_285_3.jpg" />
							<div style="position:absolute; width:100%;left:0;top:0;">
								<div class="loupan">椒江</div>
							</div>
							<div style="position:absolute; left:0;top:80%;">
								<div class="jiage">13500元/㎡</div>
							</div>
						</div>
						<h5>华润置地悦府</h5>
					</div>
				</div>
			</div>


			
			<div style="line-height: 30px; text-align: center; margin-top: 30px; margin-bottom: 30px;">
				<div>汇聚台州房产媒体力量，搭建优质楼盘线上展厅</div>
				<div>为老百姓提供安心选房大平台</div>
				<div
					style="text-indent:2em; font-size: 12px; color: #C0C0C0; text-align: left; line-height: 20px; margin-top: 15px;">
					本网站所刊载的各类内容(包括但不仅限于文字、图片、图表)仅供参考使用，并不构成任何投资建议。对于访问者根据本网站提供的信息所做出的一切行为，本网站不承担任何责任。</div>
				<div style="margin-top: 20px;">Copyright © 2022 台州城市网</div>
			</div>

		</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogToAdd: false,
				itemForm: {
					t1: "",
					t2: "",
					name: '',
					tel: '',
				},
				list_a: [],
				list_b: [],
				list_c: {},
				list_d: [],
				list_e: [],
				tabPosition: 'top',
				usable: '1',
				tabs: [{
						name: '1',
						label: '品牌馆日'
					},
					{
						name: '2',
						label: '领取优惠'
					}
				]
			}
		},
		mounted() {
			this.lista()
		},
		methods: {
			handleClick(tab) {
				console.log(tab)
			},
			add_order(itm) {
				console.log(itm)
				this.itemForm.t1 = itm.value_a
				this.itemForm.t2 = itm.value_b
				//dialogToAdd
				this.dialogToAdd = true;
			},
			lista() {
				this.$api.getAPI("data/page/13?appid=20220425&type_id=202204251001", {}).then(res => {
					console.log(res.data)
					if (res.data.code == 200) {
						var datas = res.data.data.models.detailedjson;
						this.list_a = datas;

					}
					this.listb();
				})
			},
			listb() {
				this.$api.getAPI("data/page/14?appid=20220425&type_id=202204251001", {}).then(res => {
					console.log(res.data)
					if (res.data.code == 200) {
						var datas = res.data.data.models.detailedjson;
						this.list_b = datas
					}
					this.listc()
				})
			},
			listc() {
				this.$api.getAPI("data/page/15?appid=20220425&type_id=202204251001", {}).then(res => {
					console.log(res.data)
					if (res.data.code == 200) {
						var datas = res.data.data.models;
						this.list_c = datas
					}
					this.listd()
				})
			},
			listd() {
				this.$api.getAPI("data/page/16?appid=20220425&type_id=202204251001", {}).then(res => {
					console.log(res.data)
					if (res.data.code == 200) {
						var datas = res.data.data.models.detailedjson;
						this.list_d = datas
					}
					this.liste()
				})
			},
			liste() {
				this.$api.getAPI("data/page/17?appid=20220425&type_id=202204251001", {}).then(res => {
					console.log(res.data)
					if (res.data.code == 200) {
						var datas = res.data.data.models.detailedjson;
						this.list_e = datas
					}
				})
			},
		}
	}
</script>

<style>
	.header {
		height: 15rem;
		color: #fff;
		background: url("http://www.baiduhrb.com/fjh/images/user_bg.png");
		background-size: 100% 100%;
	}

	.header .logo {
		display: block;
		float: left;
		margin-left: .8rem;
		margin-top: -4rem;
	}

	.header .logo img {
		position: relative;
		overflow-x: hidden;
		width: 45%;
		height: auto;
		top: 0px;
	}

	.m-slider {
		overflow-x: hidden;
		position: relative;
		margin-top: -10rem;
		border-radius: .45em;
	}

	.zhibo {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.loupan {
		opacity: 0.6;
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.jiage {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.h_hei {
		border-left: 5px solid #c5114f;
		padding-left: 5px;
	}

	.container-fluid {
		margin-top: 0px !important;
		max-width: 1200px;
	}

	.el-tabs__item {
		font-size: 16px !important;


	}

	.el-tabs__item is-top is-active {
		width: 50% !important;
	}

	.el-carousel__container {
		height: 200px !important;
	}





	.el-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 10px;
	}

	.bg-purple-dark {
		background-color: #fff;
		box-shadow: 1px 1px 1px #ccc;
	}

	.bg-purple {
		background: #d3dce6;
	}

	.bg-purple-light {
		background: #e5e9f2;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/wyfc/wyfc_index_show.vue